import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventFulfillmentDataByFulfillmentStepV2QueryVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
}>;


export type GetEventFulfillmentDataByFulfillmentStepV2Query = { __typename?: 'Query', getEventFulfillmentDataByFulfillmentStepV2: { __typename?: 'EventFulfillmentDataByFulfillmentStepV2', event_accounts: Array<{ __typename?: 'EventAccountInfo', id: string, name?: string | null }>, container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image?: string | null, image_url?: string | null, segment?: Types.ContainerTypeSegment | null, size_helper?: string | null, packing_unit?: number | null, color_hex_code?: string | null }>, stock_entries: Array<{ __typename?: 'EventFulfillmentStepEntryV2', event_account_id: string, container_type_id?: string | null, container_station_type_id?: string | null, total_container_stations_ordered: number, total_container_stations_delivered: number, total_container_stations_in_stock: number, total_container_stations_returned: number, total_container_stations_returned_based_on_history: number, total_containers_ordered: number, total_containers_delivered: number, total_containers_in_stock: number, total_containers_returned: number }>, stock_event_summary?: { __typename?: 'EventFulfillmentStepStockSummary', sealed_container_stations_at_warehouse: number, handed_out_container_stations: number, returned_container_stations: number, container_stations_currently_at_event_item_locations: number } | null } };


export const GetEventFulfillmentDataByFulfillmentStepV2Document = gql`
    query GetEventFulfillmentDataByFulfillmentStepV2($event_id: ID!) {
  getEventFulfillmentDataByFulfillmentStepV2(event_id: $event_id) {
    event_accounts {
      id
      name
    }
    container_types {
      id
      name
      image
      image_url
      segment
      size_helper
      packing_unit
      color_hex_code
    }
    stock_entries {
      event_account_id
      container_type_id
      container_station_type_id
      total_container_stations_ordered
      total_container_stations_delivered
      total_container_stations_in_stock
      total_container_stations_returned
      total_container_stations_returned_based_on_history
      total_containers_ordered
      total_containers_delivered
      total_containers_in_stock
      total_containers_returned
    }
    stock_event_summary {
      sealed_container_stations_at_warehouse
      handed_out_container_stations
      returned_container_stations
      container_stations_currently_at_event_item_locations
    }
  }
}
    `;

/**
 * __useGetEventFulfillmentDataByFulfillmentStepV2Query__
 *
 * To run a query within a React component, call `useGetEventFulfillmentDataByFulfillmentStepV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetEventFulfillmentDataByFulfillmentStepV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventFulfillmentDataByFulfillmentStepV2Query({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetEventFulfillmentDataByFulfillmentStepV2Query(baseOptions: Apollo.QueryHookOptions<GetEventFulfillmentDataByFulfillmentStepV2Query, GetEventFulfillmentDataByFulfillmentStepV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventFulfillmentDataByFulfillmentStepV2Query, GetEventFulfillmentDataByFulfillmentStepV2QueryVariables>(GetEventFulfillmentDataByFulfillmentStepV2Document, options);
      }
export function useGetEventFulfillmentDataByFulfillmentStepV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventFulfillmentDataByFulfillmentStepV2Query, GetEventFulfillmentDataByFulfillmentStepV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventFulfillmentDataByFulfillmentStepV2Query, GetEventFulfillmentDataByFulfillmentStepV2QueryVariables>(GetEventFulfillmentDataByFulfillmentStepV2Document, options);
        }
export type GetEventFulfillmentDataByFulfillmentStepV2QueryHookResult = ReturnType<typeof useGetEventFulfillmentDataByFulfillmentStepV2Query>;
export type GetEventFulfillmentDataByFulfillmentStepV2LazyQueryHookResult = ReturnType<typeof useGetEventFulfillmentDataByFulfillmentStepV2LazyQuery>;
export type GetEventFulfillmentDataByFulfillmentStepV2QueryResult = Apollo.QueryResult<GetEventFulfillmentDataByFulfillmentStepV2Query, GetEventFulfillmentDataByFulfillmentStepV2QueryVariables>;